import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ApplicationConfig } from '@frontend-site/shared/data';
import { VOID } from '@frontend-site/shared/utils';
import { filter, Observable, switchMap, take } from 'rxjs';
import { SessionRepository } from '../session';
import { ReleaseService } from './release.service';
import { ReleaseStore } from './release.store';

@Injectable({
    providedIn: 'root'
})
export class ReleaseDetailsResolver  {
    constructor(private session: SessionRepository, private store: ReleaseStore, private service: ReleaseService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<void> {
        const { id } = route.params;
        if (!id || this.store.currentReleaseId === +id) {
            return VOID;
        }

        return this.session.applicationConfig$
            .pipe(
                filter((appConfig) => !!appConfig),
                switchMap((appconfig) => this.service.loadRelease(id, (appconfig as ApplicationConfig).companyId)),
                take(1)
            )
            .pipe(switchMap(() => VOID));
    }
}
